import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Grid, Typography } from "@material-ui/core";
import { Label } from "../../../../components/formInputs";
import {
    SelectField,
    TextFieldCommon,
} from "../../../../components/formikFormInputs";
import FocusError from "../../../../components/FocusError";
import { REQUIRED_FIELD } from "../../../../constants";
import { useSelector } from "react-redux";
import { RootState } from "../../../../reducers";

type ClientPolicyProps = {
    clientPolicyId: any,
    clientPolicyList: any[],
    updatePolicyId: Function
};

const MultiplePolicy = ({
                            clientPolicyId,
                          clientPolicyList,
                          updatePolicyId,
                      }: ClientPolicyProps) => {

    const user = useSelector((state: RootState) => state.auth.user);

    const fieldObj = [
        {
            id: "policyNumber",
            name: "policyNumber",
            label: <Label label={"Policy Number"} />,
            isRequired: true,
            disabled: user.accessType === "client",
            component: SelectField,
            className: "fullWidthcustomFields",
            variant: "outlined",
            options: clientPolicyList,
            onSelectChange: (val: string) => {
                const selectedPolicy = clientPolicyList.find((policy:any)=> policy.value == clientPolicyId  )
                updatePolicyId(val, selectedPolicy);
            },
        },
    ];

    const initialValues = {
        policyNumber: clientPolicyId,
    };

    return (
            <>
                <Typography className="floatLeft w100 mt0 mb10" component="strong" variant="body1">
                    Select policy to view details
                </Typography>
                <Formik
                        initialValues={initialValues}
                        enableReinitialize={true}
                        validationSchema={Yup.object({
                            policyNumber: Yup.string().required(REQUIRED_FIELD),
                        })}
                        validateOnChange={true}
                        onSubmit={async (values, { setSubmitting }) => {
                            setTimeout(() => {
                                setSubmitting(false);
                            }, 500);
                        }}
                >
                    {({
                          values,
                          handleChange,
                          handleSubmit,
                      }) => (
                            <form onSubmit={handleSubmit}>
                                <FocusError offset={true} />
                                {
                                    fieldObj.map((field, index) => {
                                        return (
                                                <Grid item xs={12} md={6} lg={6} xl={4} key={index} className="mb15">
                                                    <TextFieldCommon
                                                            {...field} values={values} onChange={handleChange}
                                                    />
                                                </Grid>
                                        );
                                    })
                                }
                            </form>)}
                </Formik>
            </>
    );
};

export default MultiplePolicy;